import { defaultCountries, usePhoneInput, FlagImage } from "react-international-phone"
import styles from "./styles.module.scss"
import "react-international-phone/style.css"
import { Control, useController } from "react-hook-form"
import { Popover } from "../Popover"
import { CountriesList } from "../CountriesList"
import { observer } from "mobx-react-lite"
import { makeAutoObservable } from "mobx"
import { useMemo } from "react"
import classNames from "classnames"
import { DefaultInput } from "../DefaultInput"

class FormPhoneInputStore {
  isOpen = false

  constructor() {
    makeAutoObservable(this)
  }

  setIsOpen(value: boolean) {
    this.isOpen = value
  }
}

export const FormPhoneInput = observer(
  ({
    control,
    name,
    defaultValue,
    label,
    className,
    testID,
    parentBackgroundColor,
    lightOutline,
  }: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    control: Control<any, any>
    name: string
    defaultValue?: string
    label: string
    className?: string
    testID?: string
    parentBackgroundColor: string
    lightOutline?: boolean
  }) => {
    const state = useMemo(() => new FormPhoneInputStore(), [])

    const {
      field: { onChange, value: textValue },
      fieldState: { error: fieldError },
    } = useController({
      name,
      control,
      defaultValue: defaultValue || "",
    })

    const { inputValue, handlePhoneValueChange, inputRef, country, setCountry } = usePhoneInput({
      defaultCountry: "us",
      value: textValue,
      countries: defaultCountries,
      onChange: (data) => {
        // cast only county code phone number as empty state
        if (`+${data.country?.dialCode}` === data.phone) {
          onChange("")
          return
        }

        onChange(data.phone)
      },
    })

    return (
      <>
        <DefaultInput
          type="tel"
          value={inputValue}
          onChange={onChange}
          handlePhoneValueChange={handlePhoneValueChange}
          name={name}
          label={label}
          testId={testID}
          innerRef={inputRef}
          onFocus={(e) => {
            const length = e.target.value.length
            e.target.setSelectionRange(length, length)
          }}
          className={classNames(styles.phoneInput, className)}
          parentBackgroundColor={parentBackgroundColor}
          lightOutline={lightOutline}
          isModalOpen={true} // Set to true so label is always active
          iconLeft={
            <Popover
              isOpen={state.isOpen}
              content={
                <CountriesList
                  onSelect={(iso2) => {
                    state.setIsOpen(false)
                    setCountry(iso2)
                    inputRef.current?.focus()
                  }}
                  onClose={() => {
                    state.setIsOpen(false)
                    inputRef.current?.focus()
                  }}
                />
              }
              onClickOutside={() => {
                state.setIsOpen(false)
                inputRef.current?.focus()
              }}
            >
              <div className={styles.countrySelectorWrapper}>
                <button
                  className={styles.countrySelector}
                  onClick={() => state.setIsOpen(!state.isOpen)}
                  type="button"
                  tabIndex={-1}
                >
                  <FlagImage iso2={country.iso2} className={styles.flagImage} />
                </button>
                <div className={styles.divider} />
              </div>
            </Popover>
          }
        />
        {fieldError && fieldError.message !== "-" && (
          <p className={styles.errorMessage}>{fieldError.message}</p>
        )}
      </>
    )
  },
)
